import AppWrapper from './AppWrapper.layout';

export default AppWrapper;
